import React, { memo } from 'react';

import { useQuery } from '@tanstack/react-query';

import Table from '../../Table';

import ReportService from '../../../services/ReportService';

const cols = [
  {
    title: 'Date',
    keys: ['date'],
    type: 'date',
  },
  {
    title: 'Number',
    keys: ['pixel_number'],
    link: (row) => {
      if (!row?.id) {
        return null;
      }

      return `/bill-payments/${row.id}`;
    },
  },
  {
    title: 'Amount',
    keys: ['amount'],
    type: 'currency',
  },
  {
    title: 'Payee',
    keys: ['_vendor.name'],
    link: (row) => {
      if (!row._vendor?.id) {
        return null;
      }

      return `/vendors/${row._vendor?.id}?tab=Vendor`;
    },
  },
  {
    title: 'Status',
    keys: ['status'],
    type: 'badge',
  },
  {
    title: 'Paid from',
    keys: ['paid_from'],
  },
  {
    title: 'Check date',
    keys: ['check_disbursement_data.check_date'],
    type: 'date',
  },
  {
    title: 'Arrives by',
    keys: ['check_disbursement_data.arrives_by_date'],
    type: 'date',
  },
];

function UnclearedBillComVendorChecks() {
  const { data: unclearedBillComVendorChecks } = useQuery({
    queryKey: ['unclearedBillComVendorChecks'],
    queryFn: ReportService.getUnclearedBillComVendorChecks,
  });

  if (!unclearedBillComVendorChecks || !unclearedBillComVendorChecks.length) {
    return null;
  }

  return (
    <Table
      cols={cols}
      rows={unclearedBillComVendorChecks}
      title="Uncleared Bill.com Vendor Checks"
    />
  );
}

export default memo(UnclearedBillComVendorChecks);
